module.exports = __webpack_public_path__ + "static/media/mysql.07c28adf.png";